/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { Currency } from './Currency';
import { TaxBehavior } from './TaxBehavior';
const PutPriceCourseDataParser = /* #__PURE__ */ parsers.object([
    ['currency', Currency],
    ['amount', parsers.decimal],
    ['refundPeriod', parsers.duration, 'refund_period'],
    ['taxBehavior', TaxBehavior, 'tax_behavior'],
]);
export class PutPriceCourseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PutPriceCourseDataParser.decode(input).map(res => new PutPriceCourseData(res));
    }
    static unsafeDecode(input) {
        return PutPriceCourseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PutPriceCourseDataParser.encode(data);
    }
    static schema() {
        return PutPriceCourseDataParser.schema();
    }
}
